module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./BillDetailView.js"));
	}, "BillDetailView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=BillDetailView!./src/pages/Shop/Member/Wallet/Bill/BillDetail/BillDetailView.js
// module id = 1082
// module chunks = 431